import React from 'react';
import {Alert} from 'reactstrap';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    this.setState({
      error: error,
      info: info
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Alert color="danger" style={{ textAlign: 'center' }}>
          <h1>OOPS, Something went wrong</h1>
        </Alert>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
